import { render } from "./isVorhandenCharAndLabelMehrfach.vue?vue&type=template&id=02c08b8f&scoped=true&ts=true"
import script from "./isVorhandenCharAndLabelMehrfach.vue?vue&type=script&lang=ts"
export * from "./isVorhandenCharAndLabelMehrfach.vue?vue&type=script&lang=ts"

import "./isVorhandenCharAndLabelMehrfach.vue?vue&type=style&index=0&id=02c08b8f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c08b8f"]])

export default __exports__